import styled from "styled-components";

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 75px);
  background-color: ${({ theme }) => theme.bg.primary};
`;

export const ContentContainer = styled.div`
  width: 100%;
  z-index: 10;
  min-width: 0;
  max-width: 700px;
`;

export const Title = styled.div`
  font-size: 32px;
  font-weight: 800;
  background: radial-gradient(
    77.29% 112.55% at 22.72% 82.73%,
    #00a5d3 0.18%,
    #00b0cc 41.47%,
    #00b0cc 50.05%,
    #00b5c1 100%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const Subtext = styled.div`
  margin-top: 16px;
  color: ${({ theme }) => theme.text.title};
  font-size: 20px;
  font-weight: 400;
`;

export const List = styled.ul`
  margin: 32px 0px 0px 0px;
  padding-left: 16px;
`;

export const ListItem = styled.li`
  color: ${({ theme }) => theme.text.text};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
`;

export const ButtonContainer = styled.div`
  margin-top: 48px;
  display: flex;
  align-items: center;
  column-gap: 10px;
`;
